import React, { useEffect, useState } from 'react';
import Spinner from "./Spinner";
import axios from "axios";

import './styles.scss';
import Cookies from "js-cookie";
import {ActionCable} from "react-actioncable-provider";
import {toastr} from "react-redux-toastr";

export default ({ spinnerMessage, paymentPath, setShow, successMessage }) => {
  const [processing, setProcessing] = useState(true);
  const [paymentOptions, setPaymentOptions] = useState(null);

  useEffect(() => {
    axios.get(paymentPath).then(result => {
      const { paymentOptions, error } = result.data;

      if (error !== undefined) {
        if (error.redirectTo) {
          Cookies.set('FullyBookedMessage', error.message)
          window.location.href = error.redirectTo;
        }
        return;
      }

      setPaymentOptions(paymentOptions);
      setProcessing(true);

      axios.post(paymentOptions.confirmationUrl).then(() => { console.log('confirmation') })
    });
  }, []);

  const handleReceived = (message) => {
    switch (message.status) {
      case 'successful':
        if (paymentOptions.redirectTo) {
          window.location.href = paymentOptions.redirectTo;
        } else {
          if (successMessage) toastr.success('', successMessage);
          setProcessing(false);
          setShow(false);
        }
        break;
      case 'failed':
        setProcessing(false)
        toastr.error('', message.error_messages.join(', '));
        break;
    }
  }

  return (
    <div style={{ height: 200 }}>
      {paymentOptions && paymentOptions.modificationId &&
        <ActionCable
          channel={{ channel: 'ModificationChannel', id: paymentOptions.modificationId }}
          onReceived={handleReceived}
          onConnected={() => { console.log('onConnected')  }}
        />
      }

      <Spinner
        show={processing}
        message={spinnerMessage}
      />
    </div>
  );
};